import {fork, all, call, put} from 'redux-saga/effects';
import * as api from '../services/api';
import {loginSuccess, logout} from '../actions/action_auth';
import adminOrganizationSagas from './adminOrganizationSagas';
import adminUserSagas from './adminUserSagas';
import analyticsSagas from './analyticsSagas';
import authSagas from './authSagas';
import dashboardSagas from './dashboardSagas';
import mediaListSagas from './mediaListSagas';
import organizationSagas from './organizationSagas';
import surveySagas from './surveySagas';
import surveyListSagas from './surveyListSagas';
import surveyTrackersSagas from './surveyTrackersSagas';
import surveyDetailSagas from './surveyDetailSagas';
import dashboardConfiguration from '../components/quicksightDashboards/redux/dashboardConfiguration/sagas';
import embeddedUrlSaga from '../components/quicksightDashboards/redux/quicksightUrl/sagas';
import exportSagas from './exportSagas';
import surveyTagsSagas from './surveyTagsSagas';


function* checkLogin() {
    try {
        const response = yield call(api.authMe);
        yield put(loginSuccess(response.data));
    } catch (error) {
        yield put(logout());
    }
}

export default function* rootSaga() {
    yield all([
        fork(checkLogin),
        fork(adminOrganizationSagas),
        fork(adminUserSagas),
        fork(analyticsSagas),
        fork(authSagas),
        fork(dashboardSagas),
        fork(mediaListSagas),
        fork(organizationSagas),
        fork(surveySagas),
        fork(surveyListSagas),
        fork(surveyTrackersSagas),
        fork(dashboardConfiguration),
        fork(embeddedUrlSaga),
        fork(surveyDetailSagas),
        fork(exportSagas),
        fork(surveyTagsSagas),
    ]);
}
